import { Component, inject, Input } from "@angular/core";
import { TranslocoService } from "@jsverse/transloco";
import { ConfigurableFieldHost } from "../models/wizard/configurable-field-host.model";
import { FIELD_LABEL_DEFAULTS } from "../models/wizard/config/field-label-defaults";
import { localizeField } from "../transloco/localize-field";

@Component({
    template: '',
    standalone: false
})
export class ConfigurableFieldHostComponent extends ConfigurableFieldHost {

  private readonly _translocoService = inject(TranslocoService, { optional: true });

  @Input()
  set fieldsToConfig(value: any) {
    this._fieldsToConfig = value;
  }

  get fieldsToConfig(): any {
    return this._fieldsToConfig;
  }

  override getLabel = (fieldName: string, defaultLabel: string): string => {
    const fieldConfig = this.fieldConfig?.[fieldName];
    const lang = this._translocoService?.getActiveLang();
    if (fieldConfig) {
      // 1. Admin _i18n override
      const adminOverride = lang ? fieldConfig._i18n?.[lang]?.displayName : undefined;
      if (adminOverride) {
        return adminOverride;
      }
      // 2. Built-in default for this language
      const builtIn = lang ? FIELD_LABEL_DEFAULTS[fieldName]?.[lang] : undefined;
      if (builtIn) {
        return builtIn;
      }
      // 3. English base
      return fieldConfig.displayName;
    }
    return defaultLabel;
  }
}
